// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner_loader__2-vNv","load8":"Spinner_load8__3av5S"};